export var BuyCoinType;
(function (BuyCoinType) {
    BuyCoinType["BUY_STEEM"] = "popup_html_buy_hive";
    BuyCoinType["BUY_SBD"] = "popup_html_buy_hbd";
})(BuyCoinType || (BuyCoinType = {}));
